import { BrandLoaderDots, BrandLoaderHero } from '@/shared/ui/brand-status';

/**
 * In-shell branded loader for authenticated route Suspense.
 * Keeps sidebar/header visible while the page chunk loads.
 */
export function PageSkeleton(): JSX.Element {
  return (
    <div className="relative flex min-h-[400px] flex-col items-center justify-center px-6 py-12">
      <div className="cs-backdrop pointer-events-none absolute inset-0 rounded-3xl opacity-50" />

      <div className="relative z-10 text-center">
        <BrandLoaderHero className="mb-4" />

        <div className="mb-3 inline-flex items-center gap-1.5 rounded-full bg-brand-100 px-3 py-1.5 text-[11px] font-semibold uppercase tracking-[.16em] text-brand-700">
          <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-brand-500" />
          Loading
        </div>

        <p className="mb-5 text-sm text-ink-500">Loading page…</p>

        <BrandLoaderDots />
      </div>
    </div>
  );
}
